var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"size":160,"color":"primary","indeterminate":"","width":"6"}}),_c('div',{staticClass:"text-center mt-7 font-weight-light primary--text title"},[_vm._v("\n      Încărcare...\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }